import PropTypes from 'prop-types'

export const FormTextarea = ({
  id,
  name,
  label,
  value,
  onChange,
  onBlur,
  required = false,
  disabled = false,
  placeholder,
  rows = 4,
  maxLength,
  error,
  helperText,
}) => {
  const showCharCount = maxLength && value

  return (
    <div>
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-gray-400 mb-2">
          {label}
          {required && <span className="text-red-400 ml-1">*</span>}
        </label>
      )}
      <textarea
        id={id}
        name={name || id}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        disabled={disabled}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        className={`form-input resize-none ${
          error ? 'border-red-500 focus:border-red-500 focus:ring-red-400' : ''
        }`}
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={error ? `${id}-error` : helperText ? `${id}-help` : undefined}
      />
      <div className="flex justify-between mt-1">
        <div>
          {error && (
            <p id={`${id}-error`} className="text-sm text-red-400">
              {error}
            </p>
          )}
          {helperText && !error && (
            <p id={`${id}-help`} className="text-sm text-gray-500">
              {helperText}
            </p>
          )}
        </div>
        {showCharCount && (
          <span
            className={`text-sm ${
              value.length > maxLength * 0.9
                ? 'text-yellow-400'
                : value.length === maxLength
                  ? 'text-red-400'
                  : 'text-gray-500'
            }`}
          >
            {value.length}/{maxLength}
          </span>
        )}
      </div>
    </div>
  )
}

FormTextarea.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  maxLength: PropTypes.number,
  error: PropTypes.string,
  helperText: PropTypes.string,
}

export default FormTextarea
